import React, { useState, useEffect } from 'react';

function TypewriterText({ phrases, onComplete }) {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hasCompletedOnce, setHasCompletedOnce] = useState(false);

  const typingSpeed = 30;
  const deletingSpeed = 18;
  const pauseAfterTyping = 300;
  const pauseAfterDeleting = 100;

  // Reset animation on hover
  useEffect(() => {
    if (isHovered && hasCompletedOnce) {
      setCurrentPhraseIndex(0);
      setCurrentText('');
      setIsDeleting(false);
      setIsComplete(false);
    }
  }, [isHovered, hasCompletedOnce]);

  // Return to final phrase when hover ends
  useEffect(() => {
    if (!isHovered && hasCompletedOnce && !isComplete) {
      setCurrentPhraseIndex(phrases.length - 1);
      setCurrentText(phrases[phrases.length - 1]);
      setIsDeleting(false);
      setIsComplete(true);
    }
  }, [isHovered, hasCompletedOnce, isComplete, phrases]);

  useEffect(() => {
    if (isComplete && !isHovered) return;

    const currentPhrase = phrases[currentPhraseIndex];
    
    const handleTyping = () => {
      if (!isDeleting) {
        // Typing
        if (currentText.length < currentPhrase.length) {
          setCurrentText(currentPhrase.substring(0, currentText.length + 1));
        } else {
          // Finished typing current phrase
          if (currentPhraseIndex === phrases.length - 1) {
            // Last phrase - stay on screen
            setIsComplete(true);
            setHasCompletedOnce(true);
            if (onComplete && !hasCompletedOnce) {
              setTimeout(() => onComplete(), 500);
            }
          } else {
            // Not last phrase - start deleting after pause
            setTimeout(() => setIsDeleting(true), pauseAfterTyping);
          }
        }
      } else {
        // Deleting
        if (currentText.length > 0) {
          setCurrentText(currentText.substring(0, currentText.length - 1));
        } else {
          // Finished deleting
          setIsDeleting(false);
          setCurrentPhraseIndex((prev) => prev + 1);
          setTimeout(() => {}, pauseAfterDeleting);
        }
      }
    };

    const timeout = setTimeout(
      handleTyping,
      isDeleting ? deletingSpeed : typingSpeed
    );

    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, currentPhraseIndex, phrases, isComplete, onComplete, hasCompletedOnce, isHovered]);

  return (
    <p 
      className="about-mobile-subheader pt-1" 
      style={{ minHeight: '1.5em', cursor: 'pointer' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {currentText}
      <span className="typewriter-cursor">|</span>
    </p>
  );
}

export default TypewriterText;
